import { render, staticRenderFns } from "./cModalOpenBead.vue?vue&type=template&id=8387705a&scoped=true"
import script from "./cModalOpenBead.vue?vue&type=script&lang=js"
export * from "./cModalOpenBead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8387705a",
  null
  
)

export default component.exports